/*
 * Overview Messages
 *
 * This contains all the text for the Overview component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  header: {
    id: 'app.components.Overview.header',
    defaultMessage: 'Overview of Parent Meetings',
  },
  title: {
    id: 'app.components.Overview.title',
    defaultMessage: 'Parent Meetings for \'{title}\'',
  },
  noMeetings: {
    id: 'app.components.Overview.noMeetings',
    defaultMessage: 'No meetings planned yet.',
  },
  showEmpty: {
    id: 'app.components.Overview.showEmpty',
    defaultMessage: 'Show empty slots',
  },
  break: {
    id: 'app.components.Planner.BlockModal.break',
    defaultMessage: 'Break',
  },
  blocked: {
    id: 'app.components.Planner.BlockModal.blocked',
    defaultMessage: 'Blocked',
  },
  noSlotsAssigned: {
    id: 'app.components.Planner.Overview.noSlotsAssigned',
    defaultMessage: 'No slots assigned in this block',
  },
  join: {
    id: 'app.components.VideoConf.join',
    defaultMessage: 'Join',
  },

});
